import ZoneLmsProfile from "@/views/custom/ZoneLmsProfile";

export default {
  id: "lms_profile_id",
  key: "lms_profile",
  action: ["create","edit"],
  fields: [
    { key: "lms_profile_id", hidden: ["write"] },
    { key: "name" },
    { key: "mode", type: "select", disabled: ["edit"] },
    { key: "cp_loc", field: "cp_loc.address", value: "cp_loc.loc_id", type: "select", datatype: "id", disabled: ["edit"] },
    { key: "zone_lms_profile", type: "component", component: ZoneLmsProfile, hidden: ["list","create"] },
    { type: "action-btn" }
  ],
  options: {
    cp_loc: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
    mode: {
      key: "lms_modes",
    }
  },
  filters: {
    mode: {
      type: "select",
      // label: "name_chi",
      // value: "loc_id",
    }
  }
}